import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const plannerBase = `${u}/planner`;
const priorityBase = `${u}/priority`;

export const getPriorityExplanation = (itemId) =>
  apiFetch(`${plannerBase}/${itemId}/priority`).then(r => r.ok ? r.json() : Promise.reject(r));

export const getPriorityHistory = (itemId) =>
  apiFetch(`${plannerBase}/${itemId}/priority/history`).then(r => r.ok ? r.json() : Promise.reject(r));

// Phase 4 — user's reaction to one past decision (ACCURATE/TOO_HIGH/TOO_LOW), feeds Phase 5 personalization.
export const submitPriorityFeedback = (itemId, decisionId, feedback, comment) =>
  apiFetch(`${plannerBase}/${itemId}/priority/${decisionId}/feedback`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ feedback, comment }),
  }).then(r => r.ok ? r.json() : Promise.reject(r));

export const getPriorityFeedbackHistory = (itemId) =>
  apiFetch(`${plannerBase}/${itemId}/priority/feedback`).then(r => r.ok ? r.json() : Promise.reject(r));

// Phase 5 — personalization: per-user weight tuning + feedback-driven proposal/backtest + profile.
export const getPriorityWeights = () =>
  apiFetch(`${priorityBase}/weights`).then(r => r.ok ? r.json() : Promise.reject(r));

export const updatePriorityWeights = (weights, source) =>
  apiFetch(`${priorityBase}/weights`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ weights, source }),
  }).then(r => r.ok ? r.json() : Promise.reject(r));

export const proposePriorityWeights = () =>
  apiFetch(`${priorityBase}/weights/propose`, { method: "POST" }).then(r => r.ok ? r.json() : Promise.reject(r));

export const getPriorityProfile = () =>
  apiFetch(`${priorityBase}/profile`).then(r => r.ok ? r.json() : Promise.reject(r));
